module.exports = __webpack_public_path__ + "static/media/ObservationEmotional.d0d8ccc8.jpg";